import { BreadCrumbs } from '@/shared/ui/Breadcrumbs/Breadcrumbs'
import { AuthorizationLogView } from '@/widgets/Settings/AuthorizationLog/ui/AuthorizationLogView'

export const AuthorizationLogPage = () => {
  return (
    <>
      <BreadCrumbs />
      <AuthorizationLogView />
    </>
  )
}
